import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        height: "100%",
        padding: 0,
        margin: 0,
        backgroundColor: "#001630",
        color: "#FFFFFF",
    },
    main: {
        padding: theme.spacing(5),
        margin: 0,
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(3),
        },
        '& .listHeader': {
            fontSize: 48,
            fontWeight: 500,
            [theme.breakpoints.down("xs")]: {
                fontSize: 24,
            },
        },
        '& .listBody': {
            margin: theme.spacing(4, 0),
            '& .lisSection': {
                width: "100%",
                '& .MuiGrid-item': {
                    height: "220px",
                    '& .listItem': {
                        display: "flex",
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        height: "calc(100% - 64px)",
                        padding: theme.spacing(4, 4),
                        borderRadius:"4px",
                        '&.noItem': {
                            backgroundColor: "#07243C",
                            textAlign: "center",
                           // border: "1px solid #021B34",
                            '& .iconSection': {
                                //marginBottom: theme.spacing(4),
                                '& img': {
                                    height: "60px",
                                },
                            },
                        },
                        '&.addedItem': {
                            backgroundColor: "#0049A3",
                            textAlign: "left",
                           // border: "2px solid #002A5D",
                            position: "relative",
                            '& .removeSection': {
                                padding: "0px 28px 28px 28px",
                                position: "absolute",
                                top: 0,
                                right: 0,
                                cursor: "pointer",
                                '& .removeBtn': {
                                    '& img': {
                                        height: "10px",
                                    },
                                },
                            },
                            '& .titleSection': {
                                fontSize: 32,
                                fontWeight: 600,
                                maxWidth: "90%",
                            },
                            '& .statusSection': {
                                '& .textSection': {
                                    fontSize: 16,
                                    fontWeight: 400,
                                    //marginLeft: theme.spacing(2),
                                    display: "inline-block",
                                    marginLeft: "10px",
                                },
                                '& .loadingSection': {
                                    '& .MuiCircularProgress-root': {
                                        //
                                    },
                                },
                                '& .completedSection': {
                                    backgroundColor: "#00A348",
                                    borderRadius: "50%",
                                    //padding: theme.spacing(0.25, 0.75),
                                    width: "22px",
                                    display: "inline-block",
                                    height: "22px",
                                    maxWidth: "22px",
                                    margin: "0px",
                                    padding: "0px",                                 
                                    textAlign: "center",                                    
                                    '& img': {
                                        height: "10px",
                                        width: "10px",
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    },
    yellowBtn: {
        backgroundColor: "#FFB500",
        color: "#000000",
        fontSize: 16,
        fontWeight: 700,
        '&.addBtn': {
            width: "auto",
            minWidth: 0,
        },
        '&.Mui-disabled': {
            backgroundColor: "#FFB500",
        },
       
    },
    dialog: {
        '& .MuiPaper-root': {
            //
        },
        '& .MuiDialogTitle-root': {
            fontSize: 17,
            fontWeight: 600,
            margin: 0,
            padding: theme.spacing(2, 4),
            '& .MuiIconButton-root': {
                alignItems: "flex-start",
                padding: 0,
                margin: 0,
            },
            '& .closeButton': {
                float: "right",
                '& img': {
                    height: "16px",
                    marginTop: "4px",
                },
            },
        },
        '& .MuiDialogContent-root': {
            fontSize: 16,
            margin: 0,
            padding: theme.spacing(0.5, 4),
        },
    },
    textFieldInput: {
        fontSize: 20,
        backgroundColor: "#EFF0F2",
        color: "#00122A",
        height: "44px",
        width: "100%",
        borderRadius: "4px",
        '& input': {
            padding: "0px !important",
        },
        '&.MuiOutlinedInput-adornedEnd': {
            paddingRight: "10px !important",
        },
    },
    
}));